import api from '@pray/shared/utils/api';

export const pinComment = async ({ artistId, commentId } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!commentId) throw Error('Comment ID is required');

  const url = `/web/studio/artists/${artistId}/comments/${commentId}/pin`;
  const response = await api.executePostRequest(url);
  return response.data.data;
};
